import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/end_ticket.svg',
})
export class EndTicketIconComponent {}
